export default {
  GET_SUBSIDIARIES_REQUEST: '@@subsidiaries/GET_SUBSIDIARIES_REQUEST',
  GET_SUBSIDIARIES_SUCCESS: '@@subsidiaries/GET_SUBSIDIARIES_SUCCESS',
  GET_SUBSIDIARIES_ERROR: '@@subsidiaries/GET_SUBSIDIARIES_ERROR',
};
